import axios from "axios";
import { get, set } from "idb-keyval";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;
const clientType = "web";
const gatewayType = "ADYEN";

const fetchExistingPaymentMethods = async () => {
  return (await axios.get(`${API_URL}/api/1/payments/methods`))?.data;
};

const setDefaultPaymentMethod = async (method) => {
  await axios.put(`${API_URL}/api/1/payments/methods/${method?.token}/default`,)
};

const setDefaultPaymentMethodLocal = async (method) => {
  await localStorage.setItem("defaultPaymentMethod", JSON.stringify(method));
}

const getDefaultPaymentMethod = async () => {
  return JSON.parse(localStorage.getItem("defaultPaymentMethod"));
};

const getNewCCPaymentToken = async () => {
  return (
    await axios.get(`${API_URL}/api/1/payments/token`, {
      params: {
        client_type: clientType,
        gateway_type: gatewayType,
      },
    })
  )?.data;
};

const createNewCCPaymentMethod = async (params) => {
  return (
    await axios.post(`${API_URL}/api/1/payments/methods`, {
      client_type: clientType,
      gateway_type: gatewayType,
      ...params,
    })
  )?.data;
};

const deleteCCPaymentMethod = async (methodToken) => {
  return (
    await axios.delete(`${API_URL}/api/1/payments/methods/${methodToken}`)
  )?.data;
};

const setPaymentForRequest = async (requestId, paymentMethodToken) => {
  return await axios.post(`${API_URL}/api/1/bookings/payment_methods`, {
    requests: [requestId],
    payment_method_token: paymentMethodToken,
  });
};

const calculatePayment = async (clientId, params) => {
  const p = {
    ...params,
    should_check_for_promo_usage: false,
  }
  return (
    await axios.post(
      `${API_URL}/api/1/clients/${clientId}/bookings/calculate`,
      p
    )
  )?.data;
};

const applyPromoCode = async (promoCode) => {
  const result = await axios.post(`${API_URL}/api/1/clients/me/promos`, {
    code: promoCode,
    client_type: 'WEB'
  })
  return result?.data

}

const getBraintreeClientToken = async () => {
  return (
    await axios.get(`${API_URL}/api/1/payments/token`, {
      params: {
        client_type: clientType,
        gateway_type: 'BRAINTREE',
      },
    })
  )?.data?.token;
  // return (
  //   await axios.get(
  //     `http://localhost:5000/api/braintree/v1/getToken`
  //   )
  // )?.data?.clientToken;
}

const testBraintreeNonce = async (nonce) => {
  return (
    await axios.post(`http://localhost:5000/api/braintree/v1/sandbox`, {
      nonce
    })
  )?.data;
}


export {
  calculatePayment,
  getBraintreeClientToken,
  testBraintreeNonce,
  applyPromoCode,
  setPaymentForRequest,
  deleteCCPaymentMethod,
  createNewCCPaymentMethod,
  getNewCCPaymentToken,
  setDefaultPaymentMethod,
  getDefaultPaymentMethod,
  fetchExistingPaymentMethods,
  setDefaultPaymentMethodLocal
};
